(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ---- Mobile search opens at the top of the page ----

     The search modal is absolutely positioned inside .section-header,
     which sits below the announcement bar, so at the top of the page
     the field opened 34px down with the banner still above it.

     Do NOT solve this with position: fixed on the modal. That was
     tried on 2026-10-16 and reverted: it measured correctly in an
     emulated viewport but on real phones the field rendered under the
     browser's address bar and overflowed the viewport with the close
     button off-screen. Mobile browser chrome moves independently of
     the layout viewport.

     The header is already pinned by position: sticky; top: 0, which
     the browser resolves against its own chrome correctly. So scroll
     the banner out of the way and let the existing sticky behaviour
     put the field at the top. Once scrolled, the header is already
     there and this does nothing. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.header__search details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    var section = summary.closest('.section-header');
    if (!section) return;

    /* Read [open] after the toggle, not now. details-modal binds its
       own summary handler and sets the attribute there, and that runs
       before this document-level listener -- so testing it here sees
       the post-toggle state in both directions and never fires.

       setTimeout, not requestAnimationFrame: rAF was measured failing
       to run on this store even with the document visible, which left
       the scroll silently skipped. A zero timeout is enough to get
       past the toggle and is not frame-scheduled. */
    setTimeout(function () {
      if (!details.hasAttribute('open')) return;

      /* Land the sticky header before the field appears. Scrolling up
         reveals it by transitioning `top` from -54px over 150ms
         (.section-header.animate), and the modal is a child, so
         opening mid-reveal puts the field partly above the viewport --
         measured at -15px. On a phone that lands it under the
         browser's address bar. Dropping `animate` kills the
         transition; dropping the hidden class puts top back to 0.
         Dawn re-adds both on the next scroll. */
      section.classList.remove('animate', 'shopify-section-header-hidden');

      var bannerHeight = section.offsetTop;
      if (bannerHeight > 0 && window.scrollY < bannerHeight) {
        window.scrollTo({ top: bannerHeight, behavior: 'instant' });
      }
    }, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
